import React, { useState, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Select,
  MenuItem,
  TextField,
  FormControl,
  Box,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";

const AddPointRule = () => {
  const navigate = useNavigate();

  const [ruleName, setRuleName] = useState("");
  const [actionTrigger, setActionTrigger] = useState("");
  const [pointValue, setPointValue] = useState("");
  const [minSpend, setMinSpend] = useState("");
  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs());
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs().add(1, "month"));

  const handleSave = () => {
    const ruleData = {
      ruleName,
      actionTrigger,
      pointValue,
      minSpend,
      activationPeriod: {
        start: startDate?.format("DD MMM YYYY"),
        end: endDate?.format("DD MMM YYYY"),
      },
    };
    console.log("Saved Rule:", ruleData);
  };

  return (
    <>
      <div className="main_title">
        <h1>Add Point-Earning Rule</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-loyality-points")}>
            Loyalty Points Management
          </button>{" "}
          - Add Rule
        </p>
      </div>

      <div className="cards">
        <div className="form gap_p">
          {/* Rule Name */}
          <div className="control_group w_33">
            <label>Rule Name</label>
            <TextField
              fullWidth
              id="ruleName"
              placeholder="Enter rule name (e.g., Purchase Reward)"
              value={ruleName}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                setRuleName(e.target.value)
              }
            />
          </div>

          {/* Action / Trigger */}
          <div className="control_group w_33">
            <label>Action / Trigger</label>
            <FormControl fullWidth>
              <Select
                id="actionTrigger"
                value={actionTrigger}
                onChange={(e: SelectChangeEvent<string>) =>
                  setActionTrigger(e.target.value)
                }
                displayEmpty
              >
                <MenuItem value="">Select an action</MenuItem>
                <MenuItem value="Purchase">Purchase</MenuItem>
                <MenuItem value="Review">Submit Review</MenuItem>
                <MenuItem value="Referral">Refer a Friend</MenuItem>
                <MenuItem value="Signup">Sign Up Bonus</MenuItem>
              </Select>
            </FormControl>
          </div>

          {/* Point Value */}
          <div className="control_group w_33">
            <label>Point Value</label>
            <TextField
              fullWidth
              id="pointValue"
              placeholder="e.g., 1 point per $1 spent"
              value={pointValue}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                setPointValue(e.target.value)
              }
            />
          </div>

          {/* Min Spend / Threshold */}
          <div className="control_group w_33">
            <label>Min Spend / Threshold</label>
            <TextField
              fullWidth
              id="minSpend"
              placeholder="e.g., $10 minimum"
              value={minSpend}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                setMinSpend(e.target.value)
              }
            />
          </div>

          {/* Activation Period */}
          <div className="control_group w_100">
            <label>Activation Period</label>
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Start Date"
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  format="DD MMM YYYY"
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="End Date"
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  format="DD MMM YYYY"
                />
              </LocalizationProvider>
            </Box>
          </div>

          {/* Save Button */}
          <div className="form_btn" style={{ marginTop: "1rem" }}>
            <Button className="btn btn_primary" onClick={handleSave}>
              Save Rule
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPointRule;
